import { render, staticRenderFns } from "./newRequest.vue?vue&type=template&id=129dfa15&"
import script from "./newRequest.vue?vue&type=script&lang=js&"
export * from "./newRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports